import checker from '@/sui/tools/checker'
import units from '@/sui/data/units'
import results from '@/sui/data/results'

// Units is a preval file, it cannot include the check function
function checkUnits () {
  const c = checker('units')

  for (let y in units) {
    const uy = units[y]
    const hasDiaSpe = parseInt(y) >= 2024
    const count = uy.list.length
    const list = []
    for (let i = 0; i !== count; ++i) {
      const u = uy.list[i]
      c.checkSchema(
        'unit list',
        u,
        [
          { key: 'code', req: true, type: 'str' },
          { key: 'value', req: true, type: 'str' },
          { key: 'index', req: true, type: 'pint', check: { f: (f) => f >= 1, msg: 'expected value >= 1' } }
        ]
      )
      list.push(u.index)
    }

    list.sort((a, b) => a - b)
    let current = 1
    for (let i = 0; i !== list.length; ++i) {
      const l = list[i]
      c.check(l === current, `${y} missing index ${current}.`)
      current = l + 1

      // Ignore AD DIA for 2024+
      if (hasDiaSpe && current === 18) {
        current = 19
      }
    }
  }

  c.end()
}

export default function () {
  checkUnits()
  results.check()
  // TODO : ajouter des contrôles pour
  // - csvColumns (au bon endroit ?)
  // - microOrgs
  // - modules
  // - caracteristics
}
